<template>
  <div id="integrationsContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img class="icon-pages" src="../assets/images/navbar/ic_integrations.png" />
        <span class="page-title">{{ $t('page.integrations') }}</span>
        <span class="page-des ml-16">{{ $t('page.integrations_description') }}</span>
      </div>
      <div v-if="!userPermLock('reports')">
        <el-tabs class="styleTab" v-model="activeName">
          <el-tab-pane name="overview" default>
            <span slot="label" class="title-bar">{{ $t('page.overview') }}</span>
            <overview @clicked="goToSubPage" />
          </el-tab-pane>
          <el-tab-pane name="hrisSync">
            <span slot="label" class="title-bar">{{ $t('page.HRIS_Sync') }}</span>
            <hris-sync />
          </el-tab-pane>
          <el-tab-pane name="api">
            <span slot="label" class="title-bar">{{ $t('page.API') }}</span>
            <api />
          </el-tab-pane>
          <!-- <el-tab-pane name="GSuite">
            <span slot="label" class="title-bar">GSuite</span>
            <div>GSuite page</div>
          </el-tab-pane> -->
          <!-- <el-tab-pane name="MSTeams">
            <span slot="label" class="title-bar">MS Teams</span>
            <div>MS Teams page</div>
          </el-tab-pane> -->
          <el-tab-pane name="sso">
            <span slot="label" class="title-bar">SSO</span>
            <sso />
          </el-tab-pane>
        </el-tabs>
      </div>
      <page-locked v-else></page-locked>
    </div>
  </div>
</template>

<script>
export default {
  name: "intefrations",
  components: {
    overview: require("./Integrations/overview").default,
    hrisSync: require("./Integrations/HRIS-sync").default,
    api: require("./Integrations/api").default,
    sso: require("./Integrations/sso").default,
    pageLocked: require("./main/page-locked").default,
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "integrations", params: { tab } });
        }
      }
    }
  },
  data() {
    return {
      activeName: "overview",
      anchor: {
        overview: "overview",
        hrisSync: "hrisSync",
        api: "api",
        sso: "sso",
        // GSuite: "GSuite",
        // MSTeams: "MSTeams",
      },
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'integrations', params: { tab: "overview" } })
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "integrations") {
        this.goToSubPage(item.tab);
      }
    });
  },
  methods: {
    goToSubPage (value) {
      this.activeName = value;
    },
    userPermLock() {
      return this.$utils("permissions", {
        perm: this.$store.getters["authen/pagePermission"],
        path: "reports",
        type: "lock",
        user_type: this.$store.getters["authen/user"].user_type
      });
    },
  }
};
</script>

<style scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>
<style>
#integrationsContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#integrationsContainer .el-tabs__header {
  margin: 0;
}
</style>
